import { AccountContactMergeData } from '../../data/account.contact.merge.data';

export class FakeAccountContactMergeData extends AccountContactMergeData {

    constructor() {
        super();

        this.firstName = 'Emily';
        this.lastName = 'Johnson';
        this.name = [this.firstName, this.lastName].join(' ');
        this.email = 'emily.johnson@sample.com';
        this.mobile = '0411 111 111';
        this.workPhone = '02 9999 5551';
        this.jobTitle = 'Senior Manager';
    }

}